import { render } from "./InputSelect.vue?vue&type=template&id=6140d40a"
import script from "./InputSelect.vue?vue&type=script&lang=js"
export * from "./InputSelect.vue?vue&type=script&lang=js"

import "./InputSelect.vue?vue&type=style&index=0&id=6140d40a&lang=scss"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__